import { render } from "./TmNet.vue?vue&type=template&id=ec70f6c0&scoped=true"
import script from "./TmNet.vue?vue&type=script&lang=js"
export * from "./TmNet.vue?vue&type=script&lang=js"

import "./TmNet.vue?vue&type=style&index=0&id=ec70f6c0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec70f6c0"]])

export default __exports__